import React, { useEffect } from 'react';
import styled from 'styled-components';
import ImportStationTextMainMobile from './ImportStationTextMainMobile';
import ImportStationTextSubMobile from './ImportStationTextSubMobile';
import { useImportStationTextStore } from '../../../shared/store/importStationTextStore';
import { useCanShowProjectDetail } from '../../../shared/hooks/useProjectVisibility';
import { useModalPageStore } from '../../../shared/store/pageStore';


const ImportStationTextMobile: React.FC = () => {
  const clearSimpleList = useImportStationTextStore((s) => s.clearSimpleList);
  const canShowProject = useCanShowProjectDetail();
  const resetModalPage = useModalPageStore((s) => s.resetModalPage);

  useEffect(() => () => {
    clearSimpleList();
    resetModalPage();
  }, []);

  if (!canShowProject) return null;

  return (
    <ImportComp>
      <ContentContainer>
        <ImportStationTextMainMobile />
        <ImportStationTextSubMobile />
      </ContentContainer>
    </ImportComp>
  );
};


const ImportComp = styled.div`
  width: 100%;
  height: 82vh;
  min-height: 82vh;
  display: flex;
  flex-direction: column;
`

const ContentContainer = styled.div`
  display: flex;
  height: fit-content;
`

export default ImportStationTextMobile;
